import React from 'react';
import VBControlEnd from './vbControlEnd';
import { CssInput, CssOptionsContainer } from './vbCssComponents';

class VBMultiOption extends React.Component {
    constructor(props) {
        super();

        this.state = {
            inputValue: props.initial ? props.initial.map(itm => itm.label).join(', ') : '',
            error: props.error ? props.error : null,
            hasFocus: false,
            paddingRight: null,
            options: props.options,
            selected: props.initial ? props.initial : []
        }

        this.controlEnd = React.createRef();
        this.input = React.createRef();
        this.label = React.createRef();
        this.options_container = React.createRef();
    }

    componentDidMount() {
        //Update the padding on the input to allow any length of suffix
        this.setState({ paddingRight: this.controlEnd.current.getWidth(), labelHeight: this.label.current.clientHeight });
        document.addEventListener('keydown', this.handleOnKeyDownUp)
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleOnKeyDownUp)
    }

    onInputChange(e) {
        this.setState({ inputValue: e.target.value });
        this.filterOptions(e.target.value);
    }

    onFocus(e) {
        this.setState({ hasFocus: true, inputValue: "" })
        this.filterOptions("");

        if (this.props.onFocus) {
            this.props.onFocus(e);
        }
    }

    getClosedText () {
       return this.state.selected.map(item => { return item.label }).join(", ")
    }

    onBlur(e) {
        let error = ""
        // if validation returns a string its an error message, if null the validation passed
        if (this.props.validation) {
            error = this.props.validation(this.state.selected)
        }

        //Only hide dropdown if focus did not go to an option
        let hasFocus = false;
        let inputVal = this.getClosedText();
        if (e && e.relatedTarget) {
            if (e.relatedTarget.classList.contains("option") || e.relatedTarget.classList.contains("selected")) {
                hasFocus = true
                inputVal = ""
            }
        }

        this.setState({
            inputValue: inputVal,
            error: error,
            hasFocus: hasFocus
        });    
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    handleKeyDown(e) {
        if (e.key) {
            if (e.key == "Enter") {
                this.selectElem(e);
            }
            else {
                let new_val = this.state.value + e.key
                this.setState({ value: new_val });
                this.filterOptions(new_val);
                this.input.current.focus();
            }
        }
    }

    handleOnKeyDownUp=(event)=> {
        if (event && event.key && this.state.hasFocus) {
            const optionsContainer = this.options_container.current;
    
            if (event.key === "ArrowUp" || event.key === "ArrowDown") {
                event.preventDefault(); // Prevent page scroll
    
                const isArrowUp = event.key === "ArrowUp";
                const scrollDirection = isArrowUp ? -1 : 1;
                const optionHeight = 40;       
                let newScrollTop = optionsContainer.scrollTop + scrollDirection * optionHeight;
        
                newScrollTop = Math.max(0, Math.min(newScrollTop, optionsContainer.scrollHeight - optionsContainer.clientHeight));

                optionsContainer.scrollTop = newScrollTop;
            }
        }
    }
    selectElem(e) {
        let error = ""
        this.state.selected.push(this.props.options.find(s => s.label == e.target.innerText));
        //If validation returns a string its an error message, if null the validation passed
        if (this.props.validation) {
            error = this.props.validation(this.state.selected);
        }
        if (!this.props.autoClose) {
            this.input.current.focus();
        } 

        this.setState({
            inputValue: this.props.autoClose? this.getClosedText() : "",
            value: this.state.selected,
            error: error,
            hasFocus: !this.props.autoClose
        });
        this.options_container.current.scrollTop = 0;
        this.filterOptions("");
        if (this.props.onChange) {
            this.props.onChange(this.state.selected);
        }
    }

    removeElem(itm) {
        let error = ""
        let selected = this.state.selected
        selected = selected.filter(i => i.label != itm.label)

        //If validation returns a string its an error message, if null the validation passed
        if (this.props.validation) {
            error = this.props.validation(this.state.selected);
        }

        this.input.current.focus();
        this.setState({
            inputValue: "",
            options: this.props.options,
            value: selected,
            selected: selected,
            error: error,
            hasFocus: true
        })

        this.filterOptions("")
        
        if (this.props.onChange) {
            this.props.onChange(selected);
        }
    }

    setControlEndIcons() {
        if (this.state.hasFocus) {
            return "vb-cross " + this.props.iconFilter
        } else {
            if (this.props.error) { return "validation-failed"; }
            if (!this.props.validation || this.state.hasFocus) { return ""; }
            if (this.state.error) { return "validation-failed"; }
            if (this.state.value != "") { return "validation-ok"; }
            return "";
        }
    }

    setValidation() {
        //Only show validation styling if the user has left the input and there is something to validate with
        if (this.props.error) { return "validation-failed"; }
        if (!this.props.validation || this.state.hasFocus) { return ""; }
        if (this.state.error) { return "validation-failed"; }
        if (this.state.value != "") { return "validation-ok"; }
        return "";
    }

    filterOptions(val) {
        let visible = this.props.options.filter((itm) => itm.label.toLowerCase().startsWith(val.toLowerCase()) && (this.state.selected.find(s => s.label == itm.label) ? false : true));
        if (val != "" && visible.length == 1 && val.toLowerCase() == visible[0].label.toLowerCase()) {
            this.state.selected.push(visible[0])
            this.setState({ value: this.state.selected, inputValue: "" })
            this.filterOptions("");
            if (this.props.onChange) {
                this.props.onChange(this.state.selected);
            }
        } else {
            this.setState({ options: visible });
        }
    }


    render() {
        return (
            <div tabIndex={-1}>
                <div ref={this.label} onClick={() => { this.input.current.focus() }}>
                    {this.props.label}
                </div>
                <div className="w-100 d-inline-block position-relative">
                    <CssInput
                        ref={this.input}
                        placeholder={this.props.placeholder}
                        className={this.props.inputClass + this.setValidation()}
                        style={Object.assign({ paddingRight: this.state.paddingRight }, this.props.inputStyle)}
                        labelHeight={this.state.labelHeight + 'px'}
                        onKeyDown={this.handleOnKeyDownUp}
                        onChange={this.onInputChange.bind(this)}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        value={this.state.inputValue}
                        disabled={this.props.disabled}
                        required={this.props.required}
                        readOnly={this.props.readOnly}
                        inputMode={this.props.inputMode}
                    />
                    {/* this ads the suffix possibility and the ok/invalid checkbox */}
                    <VBControlEnd
                        ref={this.controlEnd}
                        suffix={this.props.suffix}
                        icon={this.setControlEndIcons()}
                        onClick={() => { this.input.current.blur() }} />
                    {this.state.hasFocus ?
                        <CssOptionsContainer ref={this.options_container} className={`position-absolute overflow-auto ${this.props.optionsContainerClass}`} style={this.props.optionsContainerStyle} onMouseDown={(e)=>e.preventDefault()}>
                            {/* Selected options go here */}
                            {this.state.selected.length > 0 ?
                                <div className="d-flex py-2 flex-wrap selected-container">
                                    {this.state.selected.map((itm) => {
                                        return (
                                            <div className="selected px-3 py-1 py-xl-2 pine m-1 d-inline-block w-auto" data-value={itm.value} tabIndex={-1} onClick={() => this.removeElem(itm)} onKeyDown={this.handleKeyDown.bind(this)}>
                                                {itm.label} <img style={{ height: "16px", filter: "invert(65%) sepia(87%) saturate(3328%) hue-rotate(315deg) brightness(108%) contrast(106%)" }} src="https://hosted-static.s3.eu-north-1.amazonaws.com/img/close.svg" />
                                            </div>
                                        );
                                    })}
                                </div>
                                : null}
                            <div>

                                {/* Availible options go here */}
                                {this.state.options.map((itm) => {
                                    return (
                                        <p className="option ps-2 py-xl-3" data-value={itm.id || itm.value} tabIndex={0} onClick={this.selectElem.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
                                            {itm.label}
                                        </p>
                                    );
                                })}
                            </div>
                        </CssOptionsContainer>
                        : null}
                </div>
                <div className="supp-scarlet caption pt-1">
                    {this.props.error ? this.props.error : null}
                    {!this.state.hasFocus && !this.props.error ? this.state.error : null}
                </div>
            </div>

        );
    }
}

VBMultiOption.defaultProps = { autoClose: false, inputClass: '', optionsContainerClass: '', optionsContainerStyle: null, iconFilter: 'primary-dark-filter', inputMode: '', readOnly: false };

export default VBMultiOption;